import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { ModalProvider, useModal } from './context/ModalContext';
import Header from './components/Header';
import AuthModal from './components/AuthModal';
import Home from './pages/Home';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Cart from './pages/Cart';
import CheckoutForm from './components/CheckoutForm';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import PaymentPending from './pages/PaymentPending';

const AppContent: React.FC = () => {
  const { showAuthModal, modalContext, closeAuthModal } = useModal();
  const navigate = useNavigate();

  const handleAuthModalClose = () => {
    closeAuthModal();
    // Si estamos en checkout y no hay usuario autenticado, redirigir al carrito
    if (window.location.pathname === '/checkout') {
      navigate('/carrito');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cursos" element={<Courses />} />
          <Route path="/curso/:id" element={<CourseDetail />} />
          <Route path="/carrito" element={<Cart />} />
          <Route path="/checkout" element={<CheckoutForm />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/failure" element={<PaymentFailure />} />
          <Route path="/payment/pending" element={<PaymentPending />} />
        </Routes>
      </main>
      
      {/* Modal global renderizado fuera del layout principal */}
      <AuthModal
        isOpen={showAuthModal}
        onClose={handleAuthModalClose}
        context={modalContext}
      />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <LanguageProvider>
        <AuthProvider>
          <ModalProvider>
            <CartProvider>
              <AppContent />
            </CartProvider>
          </ModalProvider>
        </AuthProvider>
      </LanguageProvider>
    </Router>
  );
};

export default App; 